export default "__VITE_ASSET__2f178da7__"